import { createContext, EActiveView, EEventType } from '@cian/authentication-widget';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const useAuthContext = () => {
  const { custom, config, httpApi, logger } = useApplicationContext();

  const authContext = createContext(
    {
      httpApi,
      logger,
      config,
      subdomain: custom.subdomain,
    },
    {
      view: {
        active: EActiveView.RememberedAccountsSelect,
      },
    },
  );

  authContext.on(EEventType.AuthenticateSucceed, () => {
    const url = new URL(window.location.href);
    url.searchParams.set('openModal', 'true');
    window.location.assign(url.toString());
  });

  return { authContext };
};
